import { CloseButton, Grid, Heading } from "@instructure/ui";
import { t } from "i18next";

const Header = ({ handleClose }) => {
  return (
    <Grid hAlign="space-between" vAlign="middle">
      <Grid.Row>
        <Grid.Col>
          <Heading level="h2" as="h1">
            {t("analyze.qualitySettingHeader")}
          </Heading>
        </Grid.Col>
        <Grid.Col width="auto">
          <CloseButton
            size="small"
            screenReaderLabel={t("global.close")}
            onClick={handleClose}
          />
        </Grid.Col>
      </Grid.Row>
    </Grid>
  );
};
export default Header;
